module.exports = __webpack_public_path__ + "img/makimono_modal_sp.74ced440.png";